import { render, staticRenderFns } from "./PageSettingsDefault.vue?vue&type=template&id=2f60c715"
import script from "./PageSettingsDefault.vue?vue&type=script&lang=ts"
export * from "./PageSettingsDefault.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f60c715')) {
      api.createRecord('2f60c715', component.options)
    } else {
      api.reload('2f60c715', component.options)
    }
    module.hot.accept("./PageSettingsDefault.vue?vue&type=template&id=2f60c715", function () {
      api.rerender('2f60c715', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/document-settings/PageSettingsDefault.vue"
export default component.exports